import type { RouteRecordRaw } from "vue-router";

export const galleryRoutes: RouteRecordRaw[] = [
  {
    path: "/gallery",
    component: () => import("../GalleryLayout.vue"),
    children: [
      {
        path: "",
        name: "gallery-index",
        component: () => import("./GalleryListPage.vue"),
      },
      {
        path: "community",
        name: "gallery-community",
        component: () => import("./community.vue"),
      },
      {
        path: "to_teach",
        name: "gallery-to-teach",
        component: () => import("./to_teach.vue"),
      },
    ],
  },
  {
    path: "/gallery/how_to",
    name: "gallery-how-to",
    component: () => import("../gallery.how_to.vue"),
  },
];
